__turbopack_context__.v({
  "contains-tracker-container": "contains-tracker-warning-module-scss-module__FIIiLG__contains-tracker-container",
  "cta-button": "contains-tracker-warning-module-scss-module__FIIiLG__cta-button",
  "details-section": "contains-tracker-warning-module-scss-module__FIIiLG__details-section",
  "entries": "contains-tracker-warning-module-scss-module__FIIiLG__entries",
  "faq": "contains-tracker-warning-module-scss-module__FIIiLG__faq",
  "faq-wrapper": "contains-tracker-warning-module-scss-module__FIIiLG__faq-wrapper",
  "headline": "contains-tracker-warning-module-scss-module__FIIiLG__headline",
  "lead": "contains-tracker-warning-module-scss-module__FIIiLG__lead",
  "read-more": "contains-tracker-warning-module-scss-module__FIIiLG__read-more",
  "warning-banner": "contains-tracker-warning-module-scss-module__FIIiLG__warning-banner",
  "warning-banner-container": "contains-tracker-warning-module-scss-module__FIIiLG__warning-banner-container",
  "warning-banner-wrapper": "contains-tracker-warning-module-scss-module__FIIiLG__warning-banner-wrapper",
});
